import { useEffect, useState } from "react";
import { IAttachment } from "interfaces/Attachments";
import { IOccurrence } from "interfaces/Occurrence";
import { useReport } from "contexts/ReportContext";
import { calculateDistance } from "utils/calculateDistance";
import { formatOccurrenceStatus } from "utils/treatOccurrenceStatus";
import { acceptPictures, denyPictures } from "services/ReportServices";

import * as S from "./styles";
import ApprovalPicsModal from "components/Modals/ApprovalPicsModal";
import { PicturesModal } from "components/Modals/PicturesModal";

export function AttachmentsTab() {
  let a = 0;
  let b = 0;
  const [externalListPic, setExternalListPic] = useState<IAttachment[]>([]);
  const [approveInitialModal, setApproveInitialModal] = useState(false);
  const [notFoundPicturesModal, setNotFoundPicturesModal] = useState(false);
  const [damagePicturesModal, setDamagePicturesModal] = useState(false);
  const [internalPicturesModal, setInternalPicturesModal] = useState(false);

  const [internalDamageList, setInternalDamageList] = useState<IAttachment[]>(
    []
  );

  const [reportPdf, setReportPdf] = useState<IAttachment>();
  const [starterKm, setStarterKm] = useState<IAttachment>();
  const [_occurrence, setOccurrence] = useState<IOccurrence>({} as IOccurrence);
  const [finishKm, setFinishKm] = useState<IAttachment>();
  const [internalList, setInternalList] = useState<IAttachment[]>([]);
  const [picturesModal, setPicturesModal] = useState(false);
  const [damagePics, setDamagePics] = useState<IAttachment[]>([]);
  const [vehiclePics, setVehiclePics] = useState<IAttachment[]>([]);
  const [firstDamagePics, setFirstDamagePics] = useState<IAttachment[]>([]);
  const [firstNotFoundPics, setFirstNotFoundPics] = useState<IAttachment[]>([]);
  const [notFoundPics, setNotFoundPics] = useState<IAttachment[]>([]);
  const { report } = useReport();

  useEffect(() => {
    let externalList: IAttachment[] = [];
    let internalDamageList: IAttachment[] = [];
    let internalList: IAttachment[] = [];
    let vehicleList: IAttachment[] = [];
    let notFoundList: IAttachment[] = [];
    let damageList: IAttachment[] = [];

    report?.attachments?.forEach((att: IAttachment) => {
      switch (att.category) {
        case "vehicle":
          vehicleList.push(att);
          break;
        case "damage":
          damageList.push(att);
          break;
        case "notFound":
          notFoundList.push(att);
          break;
        case "external":
          externalList.push(att);
          break;
        case "internal":
          internalList.push(att);
          break;
        case "internalDamage":
          internalDamageList.push(att);
          break;
        case "owner":
          externalList.push(att);
          break;
        case "starter_km":
          setStarterKm(att);
          break;
        case "finish_km":
          setFinishKm(att);
          break;
        case "report":
          setReportPdf(att);
          break;
        default:
          break;
      }
    });
    setExternalListPic(externalList);
    setInternalDamageList(internalDamageList);
    setInternalList(internalList);
    setVehiclePics(vehicleList);
    setDamagePics(damageList);
    setFirstDamagePics([
      damageList[0],
      damageList[1],
      damageList[2],
      damageList[3],
    ]);
    setNotFoundPics(notFoundList);
    setFirstNotFoundPics([
      notFoundList[0],
      notFoundList[1],
      notFoundList[2],
      notFoundList[3],
      notFoundList[4],
      notFoundList[5],
      notFoundList[6],
      notFoundList[7],
      notFoundList[8],
      notFoundList[9],
    ]);
  }, [report]);

  function renderDistance() {
    if (!report) {
      return <p>--</p>;
    }

    if (report.starterCoords && report.finishCoords) {
      try {
        const starterCoords = JSON.parse(report.starterCoords);
        const finishCoords = JSON.parse(report.finishCoords);

        const distance = calculateDistance(
          { lat: starterCoords[0], lng: starterCoords[1] },
          { lat: finishCoords[0], lng: finishCoords[1] }
        );

        return <S.Distance>{(distance / 1000).toFixed(2)}km</S.Distance>;
      } catch {
        return <p>--</p>;
      }
    }

    return <p>--</p>;
  }

  return (
    <div>
      <S.MoreDetailsContent>
        <header>
          <h2>Anexos da ocorrência</h2>
          <S.OccurrenceStatus
            variant={
              _occurrence.status === "aguardando" ||
                _occurrence.status === "aprovacao"
                ? "aguardando"
                : _occurrence.status === "andamento"
                  ? "andamento"
                  : "finalizado"
            }
          >
            {formatOccurrenceStatus(_occurrence.status)}
          </S.OccurrenceStatus>
        </header>
        <S.ReportContent>
          <div>
            <S.VehicleKm>
              <h4>Kilometragem do veículo do pronta-resposta</h4>
              <S.VehicleKmContent>
                <span>
                  <h4>Foto do KM inicial</h4>
                  {starterKm ? (
                    <a href={starterKm.url}>Abrir foto</a>
                  ) : (
                    <p>Aguardando</p>
                  )}
                </span>
                <span>
                  <h4>Foto do KM final</h4>
                  {finishKm ? (
                    <a href={finishKm.url}>Abrir foto</a>
                  ) : (
                    <p>Aguardando</p>
                  )}
                </span>
                <span>
                  <h4>Distância percorrida</h4>
                  {renderDistance()}
                </span>
              </S.VehicleKmContent>
            </S.VehicleKm>
          </div>
          {externalListPic.length !== 0 &&
            vehiclePics.length === 0 &&
            notFoundPics.length === 0 ? (
            <S.EstablishmentImagesContainer>
              <div>
                <h2>Fotos externas do local</h2>
                <S.Image
                  src={externalListPic[0].url}
                  alt="aguardando"
                  onClick={() => setPicturesModal(true)}
                />
                {externalListPic[1] && (
                  <S.DoubleImage>
                    <div>
                      <img
                        src={externalListPic[1].url}
                        alt="aguardando"
                        onClick={() => setPicturesModal(true)}
                      />
                    </div>
                    <div>
                      <img
                        src={externalListPic[2].url}
                        alt="aguardando"
                        onClick={() => setPicturesModal(true)}
                      />
                    </div>
                  </S.DoubleImage>
                )}
                {externalListPic[3] && (
                  <S.Image
                    src={externalListPic[3].url}
                    onClick={() => setPicturesModal(true)}
                    alt="aguardando"
                  />
                )}
              </div>
              <S.EstablishmentImagesDamageContainer>
                {externalListPic?.map((image, index) => {
                  if (index > 3) {
                    return (
                      <div key={index}>
                        <img
                          src={image.url}
                          alt="aguardando"
                          onClick={() => setPicturesModal(true)}
                        />
                      </div>
                    );
                  }
                })}
              </S.EstablishmentImagesDamageContainer>
            </S.EstablishmentImagesContainer>
          ) : vehiclePics.length !== 0 ? (
            <S.VehicleImagesContainer>
              <h2>Fotos do veículo</h2>
              <S.Image
                alt="aguardando"
                src={vehiclePics[0].url}
                onClick={() => setPicturesModal(true)}
              />
              {vehiclePics[1] && (
                <S.DoubleImage>
                  <img
                    alt="aguardando"
                    src={vehiclePics[1].url}
                    onClick={() => setPicturesModal(true)}
                  />
                  <img
                    alt="aguardando"
                    src={vehiclePics[2].url}
                    onClick={() => setPicturesModal(true)}
                  />
                </S.DoubleImage>
              )}
              {vehiclePics[3] && (
                <S.Image
                  alt="aguardando"
                  src={vehiclePics[3].url}
                  onClick={() => setPicturesModal(true)}
                />
              )}
              <div>
                <h2>Eventuais danos</h2>
                <S.VehicleImagesDamageContainer>
                  {firstDamagePics.map((image) => {
                    if (a < 3) {
                      a++;
                      if (image) {
                        return (
                          <div>
                            <img
                              src={image.url}
                              alt="aguardando"
                              onClick={() => setDamagePicturesModal(true)}
                            />
                          </div>
                        );
                      }
                      return <div></div>;
                    }
                    if (image && damagePics.length === 4) {
                      return (
                        <div>
                          <img
                            src={image.url}
                            alt="aguardando"
                            onClick={() => setDamagePicturesModal(true)}
                          />
                        </div>
                      );
                    }
                    return (
                      <div onClick={() => setDamagePicturesModal(true)}>
                        <p>
                          {damagePics.length - 3 > 0
                            ? `+ ${damagePics.length - 3}`
                            : ""}
                        </p>
                      </div>
                    );
                  })}
                </S.VehicleImagesDamageContainer>
              </div>
            </S.VehicleImagesContainer>
          ) : notFoundPics.length !== 0 ? (
            <S.NotFoundPictures>
              <h2>Fotos do local</h2>

              <S.PicturesContainer>
                {firstNotFoundPics?.map((image) => {
                  if (b < 9) {
                    b++;
                    if (image) {
                      return (
                        <div onClick={() => setNotFoundPicturesModal(true)}>
                          <img src={image.url} alt="aguardando" />
                        </div>
                      );
                    }
                    return <div></div>;
                  }
                  if (image && notFoundPics.length === 10) {
                    return (
                      <div onClick={() => setNotFoundPicturesModal(true)}>
                        <img src={image.url} alt="aguardando" />
                      </div>
                    );
                  }
                  return (
                    <div onClick={() => setNotFoundPicturesModal(true)}>
                      <p>
                        {notFoundPics.length - 9 > 0
                          ? `+ ${notFoundPics.length - 9}`
                          : ""}
                      </p>
                    </div>
                  );
                })}
              </S.PicturesContainer>
            </S.NotFoundPictures>
          ) : (
            <S.EstablishmentNoImagesContainer>
              <h4>Aguardando fotos...</h4>
            </S.EstablishmentNoImagesContainer>
          )}
        </S.ReportContent>
      </S.MoreDetailsContent>
      {externalListPic && externalListPic.length !== 0 && (
        <S.IntrusionContainer>
          <span>
            <h4>Houve intrusão?</h4>
            <p>{internalList && internalList.length !== 0 ? "Sim" : "Não"}</p>
          </span>
          {internalList && internalList.length !== 0 && (
            <div>
              <h4>Fotos internas do local</h4>
              <div>
                {internalList?.map((image, index) => (
                  <div key={index}>
                    <S.Image
                      src={image.url}
                      alt="aguardando"
                      onClick={() => setInternalPicturesModal(true)}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
          {internalDamageList && internalDamageList.length !== 0 && (
            <div>
              <h4>Fotos dos danos</h4>
              <div>
                {internalList?.map((image, index) => (
                  <div key={index}>
                    <S.Image
                      src={image.url}
                      alt="aguardando"
                      onClick={() => setDamagePicturesModal(true)}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </S.IntrusionContainer>
      )}

      {report && (
        <PicturesModal
          modalIsOpen={picturesModal}
          images={report?.attachments}
          setIsOpen={setPicturesModal}
        />
      )}
    </div>
  );
}
